import {connect} from "react-redux"
import State from "../../ducks/state"
import urls from "../../config/urls"

const enableCheckout = (itemCount: number) => itemCount > 0

export const mapStateToProps = (state: State) => {
    const {cleanSiteUrl} = state.request
    const {
        text: {
            checkout: {text},
        },
        settings: {xxlBreakpointEnabled},
    } = state
    const url = `${cleanSiteUrl}${urls.checkout.url}`
    return {
        enable: enableCheckout(state.shoppingBag.itemCount),
        text,
        url,
        templating: state.template,
        xxlBreakpointEnabled,
    }
}

export default connect(mapStateToProps)
